export const CHATBOT_TITLE = { type: 'GROUP', title: 'Chatbot attributes' }
export const WIDGET_TITLE = { type: 'GROUP', title: 'Widget attributes' }
export const FACEBOOK_TITLE = { type: 'GROUP', title: 'Facebook attributes' }
export const WHATSAPP_TITLE = { type: 'GROUP', title: 'Whatsapp attributes' }
export const TWILIO_TITLE = { type: 'GROUP', title: 'Twilio attributes' }
